import React from 'react';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { RestaurantCartProvider } from './happyspace-restaurant-sdk';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import LocationsPage from './pages/LocationsPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderStatusPage from './pages/OrderStatusPage';

export default function App() {
  return (
    <HelmetProvider>
      <RestaurantCartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#FFFBEB] flex flex-col">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/locations" element={<LocationsPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-status/:orderId" element={<OrderStatusPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </RestaurantCartProvider>
    </HelmetProvider>
  );
}